export default __webpack_public_path__ + "static/media/neighborhood3.a4d7bf67.webp";